module.exports = __webpack_public_path__ + "static/media/mu.c7bd1436.svg";